import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { CardAssociationService, CardCustomerAssociation } from "app/services/customer/card-association.service";
import { Campaign3BreadcrumbComponent } from "app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component";
import { Campaign3KontableComponent } from "app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component";
import { BreadCrumbModel } from "app/views/campaign-3/models/campaign-3-breadcrumb.model";
import { MessageService } from "primeng/primeng";

@Component({
  selector: 'app-card-association',
  templateUrl: './card-association.component.html',
  styleUrls: ['./card-association.component.css']
})
export class CardAssociation implements OnInit {


  @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
  @ViewChild('associations') kontableComponent: Campaign3KontableComponent;

  breadcrumbs: Array<BreadCrumbModel> = [];
  paginationType = Campaign3KontableComponent.ServerPagination;
  dateFilter = Campaign3KontableComponent.DateFilter;
  numberFilter = Campaign3KontableComponent.NumberFilter;
  textFilter = Campaign3KontableComponent.TextFilter;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  noFilter = Campaign3KontableComponent.NoFilter;

  statusList: Array<{ label: string, value: string }>;

  showBreadCrumb: boolean = false;
  readyTable:boolean = false;
  pageSubject = "CardCustomerAssociation";

  //translations
  validLabel: string;
  errorLabel:string;
  validLabelEmailError:string

  constructor(
    public srvCalendar: CalendarTranslateService,
    private srvNotify: MessageService,
    private translateService: TranslateService,
    public router: Router,
    private associationService : CardAssociationService
  ) { }
  //todo inserire le traduzioni
  private initBreadCrumbs() {

    let breadCrumbDistribution;

    this.translateService.get([
      'breadCrumb.associations',
      'acm.valid',
      'common.error',
      'cardAssociation.validErrorMail'
    ]).subscribe(translations => {
      breadCrumbDistribution = translations['breadCrumb.associations'];
      this.validLabel=translations['acm.valid'];
      this.validLabelEmailError=translations['cardAssociation.validErrorMail'];
      this.errorLabel=translations['common.error'];
      this.breadcrumbs = [
        { code: 'bc1', description: breadCrumbDistribution, routerLink: '/card-association' },

      ];
      this.statusList.push({label: this.validLabel, value: '0'});
      this.statusList.push({label: this.validLabelEmailError, value: 'N'});
      this.statusList.push({label: this.errorLabel, value: '1'});
      this.readyTable=true;
      this.showBreadCrumb = true;
    });
  }



  ngOnInit(): void {
    this.statusList = [];
    this.statusList.push({ label: '', value: null });
    this.initBreadCrumbs()
  }

  //quando premo per associare una nuova carta
  onOpenCreation() {
    this.router.navigate(['/card-association/new']);
  }

  //ho cliccato uno dei link della breadcrumb
  breadcrumbClicked(breadcrumb: BreadCrumbModel) {
    if (breadcrumb.routerLink) {
        this.router.navigate([breadcrumb.routerLink]);
    } else {
        console.log("Nessuna route implementata");
    }
}
getStatusDescription(returnCode: string): string {
  if (returnCode === '0') {
    return this.validLabel;
  } else if (returnCode === 'N') {
    return this.validLabelEmailError;
  } else {
    return this.errorLabel;
  }
}


reSendEmail(row: CardCustomerAssociation) {
  let id = row.id;
  let customerId = row.customerId;

  this.associationService.sendEmail(id, customerId).subscribe(
    res => {
      console.log(res);
      this.kontableComponent.refresh();

      // Notifica di successo
      this.srvNotify.add({
        severity: 'success',
        summary: this.translateService.instant('common.success'),
        detail: this.translateService.instant('cardAssociation.sent_successfully'),
        life: 5000
      });
    }
    
  );
}


}






// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/card-association/card-association.component.ts